import React, { FC } from 'react';
import { useAuthFlow } from '../../shared';
import { IonPage, useIonViewWillEnter } from '@ionic/react';
import { AppHeader_v2 as AppHeader } from '@mindly/ui-components';
import { RouteComponentProps } from 'react-router-dom';
import { PrivateRoutes, PublicRoutes } from '../../routes/navigation';
import { ProfileFirstNameWidget } from '../../widgets';

const NeedUpdatePersonalDataFirstNamePage: FC<RouteComponentProps> = ({ history }) => {
  const { authUser } = useAuthFlow();

  useIonViewWillEnter(() => {
    if (!authUser) {
      history.push(PublicRoutes.AUTH);
      return;
    }
  }, []);

  return (
    <IonPage>
      <AppHeader />
      <ProfileFirstNameWidget
        onSuccess={() => {
          history.push(PrivateRoutes.NEED_UPDATE_PERSONAL_DATA_LAST_NAME);
        }}
      />
    </IonPage>
  );
};

export default NeedUpdatePersonalDataFirstNamePage;
